export default __webpack_public_path__ + "static/media/top-ten-block-4.eea8271a.svg";